<template>
	<div class="gb-list-group">
		<GBScheduleListRow
			v-bind:item="item"
			v-bind:narrow="narrow"
			v-bind:isEditable="isEditable"
			v-bind:watchSlide="watchSlide"
			v-bind:use_photo="use_photo"
			v-bind:ghost_schedule="ghost_schedule"
			v-bind:project_pinned="getProjectPinned"
			v-on:schedule-list-row-slide="onScheduleListRowSlide"
			v-on:show-project-info="onClickShowProjectInfo"
			v-on:show-member-info="onClickShowMemberInfo"
			v-on:show-add-member="onClickShowAddMember"
			v-on:update-dataset="onUpdateDataSet"
			ref="parent"
		/>
		<TransitionExpand>
			<div v-if="isExpanded">
				<GBScheduleListRow
					v-for="child in filteringChildren"
					v-bind:key="child.codeWithType"
					v-bind:narrow="narrow"
					v-bind:parent="item"
					v-bind:item="child"
					v-bind:isEditable="isEditable"
					v-bind:watchSlide="watchSlide"
					v-bind:ghost_schedule="ghost_schedule"
					v-on:schedule-list-row-slide="onScheduleListRowSlide"
					v-bind:project_pinned="getProjectPinned"
					v-on:show-project-info="onClickShowProjectInfo"
					v-on:show-member-info="onClickShowMemberInfo"
					v-on:update-dataset="onUpdateDataSet"
					v-on:delete-member-from-project="onDeleteMemberFromProject"
					ref="children"
				/>
			</div>
		</TransitionExpand>
	</div>
</template>
<script>
import GBScheduleListRow from './GBScheduleListRow';
import TransitionExpand from './TransitionExpand';
export default {
	name: 'GBScheduleListRowGroup',
	components: {
		GBScheduleListRow,
		TransitionExpand,
	},
	props: [
		"item",
		"isEditable",
		"watchSlide",
		"narrow",
		"scroll_to",
		"use_photo",
		"ghost_schedule",
	],
	computed: {
		isExpanded: function() {
			return this.$store.getters.isExpandedScheduleListRow(this.item);
		},
		filteringChildren: function() {
			return this.$store.getters.filteringChildlen(this.item.children, this.item.alert);
		},
		getProjectPinned: function() {
			let pinned = this.$store.getters.projectPinned(this.item.code);
			
			if (pinned === undefined) {
				pinned = this.$store.getters.projectPinned('default');
			}
			return pinned;
		},
	},
	methods: {
		onScheduleListRowSlide: function(e) {
			this.$emit('schedule-list-row-slide', e);
		},
		onClickShowProjectInfo: function(e) {
			this.$emit("show-project-info", e);
		},
		onClickShowMemberInfo: function(e) {
			this.$emit("show-member-info", e);
		},
		onClickShowAddMember: function(e) {
			this.$emit("show-add-member", e);
		},
		onUpdateDataSet: function() {
			this.$emit("update-dataset");
		},
		onDeleteMemberFromProject: function(e) {
			this.$emit("delete-member-from-project", e);
		},
	},
	watch: {
		scroll_to: function() {
			let scroll_to = this.scroll_to;
			if (!scroll_to)
				return;

			if (this.item.isProject && scroll_to.project_code) {
				if (scroll_to.project_code === this.item.code) {
					let el = this.$el;

					if (scroll_to.member) {
						this.refs.children.some(c => {
							if (c.item.code === scroll_to.member_code) {
								el = c.$el;
								return true;
							}
							return false;
						});
					}

					el.scrollIntoView(true);
				}
			} else if (this.item.isMember && scroll_to.member_code) {
				if (scroll_to.member_code === this.item.code) {
					let el = this.$el;

					if (scroll_to.project_code) {
						this.refs.children.some(c => {
							if (c.item.code === scroll_to.project_code) {
								el = c.$el;
								return true;
							}
							return false;
						});
					}

					el.scrollIntoView(true);
				}
			}
		},
	},
}
</script>
<style>
	.gb-list-group {
		border-bottom: 2px solid #a9a9a9;
	}
</style>
